<template>
    <div class="container-box">
        <div v-if="catalogsOne.length === 0" class="blank-box">
            <img :src="$images.material.blank" alt="blank" />
            <span class="word">暂无素材库</span>
        </div>
        <div v-else class="catalogs-box">
            <div class="left-box">
                <p
                    v-for="(item, index) in catalogsOne"
                    :key="index"
                    class="title"
                    :class="{active: `${catalogOne}` === `${item.id}`}"
                    @click.stop="selectCatalogOne(item)"
                >{{item.value}}</p>
            </div>
            <div class="right-box">
                <div
                        v-for="(item1,index1) in catalogsTwo"
                        :key="`index1{${index1}}`"
                        class="title-box">
                    <p class="title"
                       :class="{active: `${catalogTwo}` === `${item1.id}`}"
                       @click.stop="selectCatalogTwo(item1)">{{item1.value}}</p>
                    <div class="title-two">
                        <p
                            v-for="(item2,index2) in item1.childrens"
                            :key="`index2{${index2}}`"
                            class="title"
                            :class="{active: `${catalogTwo}` === `${item2.id}`}"
                            @click.stop="selectCatalogTwo(item2)"
                        >{{item2.value}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "catalogs",
        props: {
            data: Array,
            selectCatalog: [String, Number],
            isShop: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            catalogsOne () {
                return this.data.map(v=>{
                    return {
                        id: v.id,
                        value: v.name,
                        childrens: v.childrens
                    }
                })
            }
            // catalogsTwo () {
            //     return [
            //         {
            //             id: 11, value: '透明图11', parentId: 1, childrens: [
            //                 {id: 111, value: '透明图111'},
            //                 {id: 122, value: '透明图122'},
            //                 {id: 133, value: '透明图133'},
            //                 {id: 133, value: '透明图133'},
            //                 {id: 133, value: '透明图133'},
            //                 {id: 133, value: '透明图133'},
            //                 {id: 133, value: '透明图133'},
            //             ]
            //         },
            //         {
            //             id: 12, value: '透明图12', parentId: 1, childrens: [
            //                 {id: 111, value: '透明图111'},
            //                 {id: 122, value: '透明图122'},
            //                 {id: 133, value: '透明图133'},
            //             ]
            //         },
            //     ]
            // }
        },
        watch: {
            isShop: {
                handler () {
                    this.$nextTick(()=>{
                        let fn = setTimeout(()=>{
                            this.selectCatalogOne(this.catalogsOne[0])
                            clearTimeout(fn)
                        }, 300)
                    })
                },
                deep: true,
                immediate: true
            },
            selectCatalog(vl) {
                this.catalogTwo = vl
            },
            catalogTwo(vl){
                this.$emit('update:selectCatalog', vl)
            }
        },
        mounted(){
            // 默认获取第一个列表
            this.selectCatalogOne(this.catalogsOne[0])
        },
        data () {
            return {
                catalogOne: '',
                catalogTwo: '',
                catalogsTwo: []
            }
        },
        methods: {
            selectCatalogOne (item) {
                try {
                    // console.log('111-7==>', item, typeof Array.from(item.childrens))
                    this.catalogOne = item.id

                    // 计算二级及三级目录内容
                    let childrenArr = item.childrens
                    if(!item.childrens || item.childrens.length === 0){
                        childrenArr = ([{id: item.id, name: item.value}])
                    }
                    // console.log('二级==>', childrenArr, typeof childrenArr)
                    this.catalogsTwo = this.setTwoData(childrenArr)
                } catch (e) {
                    console.log('等待设置初始分类==>')
                }
            },
            // 计算catalogsTwo 内容
            setTwoData (arr) {
              let list = []
                if(arr && arr.length>0) {
                    list = arr.map(v => {
                        return {
                            id: v.id,
                            value: v.name,
                            childrens: this.getAllChidrens([], v.childrens || [])
                        }
                    })
                }
              return list
            },
            // 获取所有子项，平铺成一级
            getAllChidrens(oldArr, arr){
                arr.map(v=>{
                    oldArr.push({
                        id: v.id,
                        value: v.name,
                    })
                    if(v.childrens) this.getAllChidrens(oldArr, v.childrens)
                  })
                return oldArr
            },
            selectCatalogTwo (item) {
                this.catalogTwo = item.id
                this.$emit('onCatalogs', item.id)
            }
        }
    }
</script>

<style lang="scss" scoped>
.blank-box{
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    margin: 30px 0px;
    flex-direction: column;

    .word {
        font-size:14px;
        font-weight:400;
        color:rgba(48,49,51,1);
        line-height:20px;
        position: relative;
        left: -6px;
        margin-top: 10px;
    }
}
.catalogs-box{
    display: flex;
    flex-direction: row;
    max-height: 100vh;

    .left-box{
        width:120px;
        background:rgba(250,250,250,1);
        box-shadow:1px 0px 0px 0px rgba(220,223,230,1);
        border-radius:4px 0px 0px 4px;
        padding-top: 14px;
        padding-bottom: 100px;
        overflow-y: auto;

        .title {
            font-size:16px;
            color:#303133;
            line-height:40px;
            padding: 0px 20px;
            cursor:pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &.active, &:hover{
                background-color: #e7622e;
                color: white;
            }
        }
    }
    .right-box{
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 14px 30px;
        overflow-y: auto;

        .title-box {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            align-items: flex-start;

            & > .title {
                width: 100%;
                margin-top: 16px;
                height: 22px;
                font-size: 16px;
                color: rgba(48, 49, 51, 1);
                line-height: 22px;
                cursor: pointer;

                &:hover, &.active{
                    color: #e7622e;
                }
            }

            .title-two {
                width: 100%;
                margin-top: 14px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                flex-wrap: wrap;
                border-bottom: 1px solid #f0f0f0;
                padding-bottom: 16px;
                /*align-items: center;*/

                & > .title{
                    height:20px;
                    font-size:14px;
                    color:#909399;
                    line-height:20px;
                    margin-right: 14px;
                    margin-bottom: 8px;
                    cursor: pointer;

                    &:hover, &.active{
                        color: #e7622e;
                    }
                }
            }

            &:nth-last-child(1){
                .title-two {
                    border-bottom: none;
                }
            }
        }
    }
}
</style>
